import { gql } from '@apollo/client';

export const fetchQuotesOrderDetails = gql`
  query fetchQuotesOrderDetails($id: String, $txaId: String) {
    quote(id: $id, txaId: $txaId) {
      id
      lineItems {
        metadata {
          legacyInvoiceId
        }
        lineItemId
      }
    }
  }
`;
